export { default as CustomSlider } from './custom-slider';
export type {
    ItemType,
    AuthorType,
    ContentItemType,
    ImageType,
} from './types';
